export default __webpack_public_path__ + "static/media/Image.f1546b00.svg";